import type { PasswordInputProps } from '@mantine/core';
import { PasswordInput } from '@mantine/core';
import React from 'react';

import styles from './PasswordField.module.css';

export const LBPasswordField = React.forwardRef<
  React.ElementRef<typeof PasswordInput>,
  PasswordInputProps
>((props, ref) => (
  <PasswordInput
    {...props}
    ref={ref}
    classNames={styles}
    inputWrapperOrder={['label', 'input', 'error', 'description']}
  />
));
